// Inside AppRoutes.tsx or components/auth/AuthenticatedRoutesWrapper.tsx

import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import AppProviders from '@/components/app/AppProviders';

export const AuthenticatedRoutesWrapper = () => {
    return (
        <AuthProvider>
            <AppProviders>
                {/* <Outlet /> renders the child route (e.g., DashboardLayout) */}
                <Outlet />
            </AppProviders>
        </AuthProvider>
    );
};